export { ReactComponent as IconArrowLeft } from '@/assets/svgs/icon-arrow-left.svg'
export { ReactComponent as IconArrowsRight } from '@/assets/svgs/icon-arrows-right.svg'
export { ReactComponent as IconDiscordMid } from '@/assets/svgs/icon-discord-mid.svg'
export { ReactComponent as IconDiscord } from '@/assets/svgs/icon-discord.svg'
export { ReactComponent as IconEmoji1 } from '@/assets/svgs/icon-emoji-1.svg'
export { ReactComponent as IconEmoji2 } from '@/assets/svgs/icon-emoji-2.svg'
export { ReactComponent as IconEmoji3 } from '@/assets/svgs/icon-emoji-3.svg'
export { ReactComponent as IconEmoji4 } from '@/assets/svgs/icon-emoji-4.svg'
export { ReactComponent as IconExit } from '@/assets/svgs/icon-exit.svg'
export { ReactComponent as IconMuseSolid } from '@/assets/svgs/icon-muse-solid.svg'
export { ReactComponent as IconStar } from '@/assets/svgs/icon-star.svg'
export { ReactComponent as IconUser } from '@/assets/svgs/icon-user.svg'
export { ReactComponent as IconWechatSolid } from '@/assets/svgs/icon-wechat-solid.svg'
export { ReactComponent as IconWechat } from '@/assets/svgs/icon-wechat.svg'
